"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInputClassName = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
function getInputClassName(prefixCls, bordered, size, disabled, direction) {
    var _a;
    return (0, classnames_1.default)(prefixCls, (_a = {},
        _a["".concat(prefixCls, "-sm")] = size === 'small',
        _a["".concat(prefixCls, "-lg")] = size === 'large',
        _a["".concat(prefixCls, "-disabled")] = disabled,
        _a["".concat(prefixCls, "-rtl")] = direction === 'rtl',
        _a["".concat(prefixCls, "-borderless")] = !bordered,
        _a));
}
exports.getInputClassName = getInputClassName;
//# sourceMappingURL=utils.js.map